<template>
  <Transition name="dropdown">
    <div v-if="isOpen"
      class="absolute top-full left-1/2 -translate-x-1/2 mt-2 w-[320px] bg-interactive-interactiveBg border border-border-line shadow-lg z-50"
      @mouseenter="handleMouseEnter" @mouseleave="handleMouseLeave">
      <div class="space-y-3" style="width: 20rem;">
        <!-- Points -->
        <a href="https://app.hyperliquid.xyz/points"
          class="flex items-start gap-3 p-3  hover:bg-interactive-interactiveBgHover transition-colors group">
          <div class="flex-shrink-0 mt-1">
            <!-- Иконка стопки из трех монет с долларовым знаком на верхней монете для Points -->
            <svg width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg"
              class="!w-6 !h-6 text-t-third block">
              <path
                d="M17 11.5C19.7614 11.5 22 13.7386 22 16.5C22 19.2614 19.7614 21.5 17 21.5C14.2386 21.5 12 19.2614 12 16.5C12 13.7386 14.2386 11.5 17 11.5ZM11 3.5C14.866 3.5 18 4.84315 18 6.5V10.584C17.6747 10.5294 17.3408 10.5 17 10.5C16.8968 10.5 16.7943 10.5017 16.6924 10.5068C16.7078 10.4922 16.724 10.4793 16.7383 10.4648C16.9681 10.2318 17 10.076 17 10V8.04492C15.7752 8.91636 13.5467 9.5 11 9.5C8.45329 9.5 6.22478 8.91636 5 8.04492V10C5 10.076 5.03186 10.2318 5.26172 10.4648C5.49608 10.7023 5.88507 10.9625 6.44434 11.2021C7.55931 11.68 9.16926 12 11 12C11.7943 12 12.5466 11.9363 13.2354 11.8291C12.8294 12.1567 12.467 12.5358 12.1582 12.957C11.7814 12.984 11.3946 13 11 13C8.45329 13 6.22478 12.4164 5 11.5449V14C5 14.076 5.03186 14.2318 5.26172 14.4648C5.49608 14.7023 5.88507 14.9625 6.44434 15.2021C7.55931 15.68 9.16926 16 11 16C11.0075 16 11.015 15.999 11.0225 15.999C11.0088 16.1643 11 16.3312 11 16.5C11 16.6681 11.0089 16.8344 11.0225 16.999C11.015 16.999 11.0075 17 11 17C8.45329 17 6.22478 16.4164 5 15.5449V18.0996C5 18.1756 5.03204 18.3316 5.26172 18.5645C5.49606 18.8019 5.88515 19.0621 6.44434 19.3018C7.55931 19.7796 9.16926 20.0996 11 20.0996C11.3999 20.0996 11.789 20.0806 12.165 20.0518C12.412 20.3874 12.6928 20.6964 13.0029 20.9736C12.3683 21.0547 11.6961 21.0996 11 21.0996C7.13401 21.0996 4 19.7565 4 18.0996V6.5C4 4.84315 7.13401 3.5 11 3.5ZM17 12.5C14.7909 12.5 13 14.2909 13 16.5C13 18.7091 14.7909 20.5 17 20.5C19.2091 20.5 21 18.7091 21 16.5C21 14.2909 19.2091 12.5 17 12.5ZM19.5605 16.5L17 19.0605L14.4395 16.5L17 13.9395L19.5605 16.5ZM15.8535 16.5L17 17.6465L18.1465 16.5L17 15.3535L15.8535 16.5ZM11 4.5C9.16926 4.5 7.55931 4.82003 6.44434 5.29785C5.88507 5.53754 5.49608 5.79769 5.26172 6.03516C5.03186 6.26816 5 6.42398 5 6.5C5 6.57602 5.03186 6.73184 5.26172 6.96484C5.49608 7.20231 5.88507 7.46246 6.44434 7.70215C7.55931 8.17997 9.16926 8.5 11 8.5C12.8307 8.5 14.4407 8.17997 15.5557 7.70215C16.1149 7.46246 16.5039 7.20231 16.7383 6.96484C16.9681 6.73184 17 6.57602 17 6.5C17 6.42398 16.9681 6.26816 16.7383 6.03516C16.5039 5.79769 16.1149 5.53754 15.5557 5.29785C14.4407 4.82003 12.8307 4.5 11 4.5Z"
                fill="currentColor"></path>
            </svg>
          </div>
          <div class="flex-1 min-w-0">
            <div class="flex items-center gap-2 mb-1">
              <h4 class="text-subtitle2 text-t-primary font-medium">Points</h4>
              <span
                class="itext-caption2 dark:text-interactive-primary text-t-link bg-interactive-interactive02 px-1" style="font-size: 10px;">
                NEW
              </span>
            </div>
            <p class="text-caption1 text-t-third">Earn points for the $ASTER airdrop</p>
          </div>
        </a>

        <!-- Trade & Earn -->
        <a href="https://hyperscreener.asxn.xyz/home"
          class="flex items-start gap-3 p-3  hover:bg-interactive-interactiveBgHover transition-colors group">
          <div class="flex-shrink-0 mt-1">
            <!-- Иконка графика с восходящим трендом и долларовым знаком для Trade & Earn -->
            <svg class="!w-6 !h-6 text-t-third block" width="24" height="25" viewBox="0 0 24 25" fill="none"
              xmlns="http://www.w3.org/2000/svg">
              <path
                d="M16.5 12C17.6935 12 18.8377 12.4744 19.6816 13.3184C20.5256 14.1623 21 15.3065 21 16.5C21 17.6935 20.5256 18.8377 19.6816 19.6816C18.8377 20.5256 17.6935 21 16.5 21C15.3065 21 14.1623 20.5256 13.3184 19.6816C12.4744 18.8377 12 17.6935 12 16.5C12 15.3065 12.4744 14.1623 13.3184 13.3184C14.1623 12.4744 15.3065 12 16.5 12ZM6 20H5V14H6V20ZM10 20H9V12H10V20ZM16.5 13C15.5717 13 14.6818 13.369 14.0254 14.0254C13.369 14.6818 13 15.5717 13 16.5C13 17.4283 13.369 18.3182 14.0254 18.9746C14.6818 19.631 15.5717 20 16.5 20C17.4283 20 18.3182 19.631 18.9746 18.9746C19.631 18.3182 20 17.4283 20 16.5C20 15.5717 19.631 14.6818 18.9746 14.0254C18.3182 13.369 17.4283 13 16.5 13ZM17 13.5V14.25H18V15.25H16.0684C15.8937 15.2502 15.7502 15.3937 15.75 15.5684C15.75 15.7215 15.8598 15.8527 16.0098 15.8809L17.416 16.1377C18.0408 16.2535 18.4971 16.7972 18.4971 17.4346C18.497 18.1626 17.9058 18.7529 17.1777 18.7529H16.9971V19.5029H15.9971V18.7529H14.9971V17.7529H17.1777C17.3527 17.7529 17.497 17.6095 17.4971 17.4346C17.4971 17.2814 17.3873 17.1502 17.2373 17.1221L15.8311 16.8652C15.2062 16.7495 14.75 16.2058 14.75 15.5684C14.7502 14.8623 15.3033 14.2873 16 14.2529V13.5H17ZM20 8.5H19V5.72168L18.8379 5.87207L13.5312 10.3369L13.1777 10.6592L12.8408 10.3213L9.14355 6.625L3.99023 10.375L3.58789 10.6689L3 9.85938L3.40332 9.56543L8.90332 5.56543L9.25 5.31543L13.2158 9.28125L18.1689 5.1377L18.3125 5.00586H15.5059V4.00586H16.0059L16 4H20V8.5Z"
                fill="#999999"></path>
            </svg>
          </div>
          <div class="flex-1 min-w-0">
            <h4 class="text-subtitle2 text-t-primary font-medium mb-1">Trade & Earn</h4>
            <p class="text-caption1 text-t-third">Earn APY on collateral while you trade</p>
          </div>
        </a>

        <!-- Rewards Hub -->
        <a href="https://app.hyperliquid-testnet.xyz/drip"
          class="flex items-start gap-3 p-3  hover:bg-interactive-interactiveBgHover transition-colors group">
          <div class="flex-shrink-0 mt-1">
            <!-- Иконка подарка/подарочной коробки для Rewards Hub -->
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"
              class="!w-6 !h-6 text-t-third block">
              <path fill-rule="evenodd" clip-rule="evenodd"
                d="M13.4424 4.35879C14.3483 2.66106 16.7598 2.60026 17.75 4.25039L17.8369 4.40664C18.2893 5.29359 18.1441 6.28419 17.6152 7.00039H21V12.0004H20V21.0004H4V12.0004H3V7.00039H6.38477C5.85596 6.28418 5.71089 5.29351 6.16309 4.40664L6.25 4.25039C7.24015 2.60025 9.65172 2.66108 10.5576 4.35879L11.9668 7.00039H12.0332L13.4424 4.35879ZM5 20.0004H9V12.0004H5V20.0004ZM10 20.0004H14V8.00039H10V20.0004ZM15 20.0004H19V12.0004H15V20.0004ZM4 11.0004H9V8.00039H4V11.0004ZM15 11.0004H20V8.00039H15V11.0004ZM9.67578 4.82949C9.16955 3.88061 7.87387 3.78937 7.22754 4.59219L7.10742 4.76504C6.51796 5.74862 7.22628 7.00001 8.37305 7.00039H10.833L9.67578 4.82949ZM16.7725 4.59219C16.1261 3.78939 14.8304 3.8806 14.3242 4.82949L13.167 7.00039H15.627C16.774 7.00025 17.4824 5.74876 16.8926 4.76504L16.7725 4.59219Z"
                fill="currentColor"></path>
              <path fill-rule="evenodd" clip-rule="evenodd"
                d="M13.4424 4.35879C14.3483 2.66106 16.7598 2.60026 17.75 4.25039L17.8369 4.40664C18.2893 5.29359 18.1441 6.28419 17.6152 7.00039H21V12.0004H20V21.0004H4V12.0004H3V7.00039H6.38477C5.85596 6.28418 5.71089 5.29351 6.16309 4.40664L6.25 4.25039C7.24015 2.60025 9.65172 2.66108 10.5576 4.35879L11.9668 7.00039H12.0332L13.4424 4.35879ZM5 20.0004H9V12.0004H5V20.0004ZM10 20.0004H14V8.00039H10V20.0004ZM15 20.0004H19V12.0004H15V20.0004ZM4 11.0004H9V8.00039H4V11.0004ZM15 11.0004H20V8.00039H15V11.0004ZM9.67578 4.82949C9.16955 3.88061 7.87387 3.78937 7.22754 4.59219L7.10742 4.76504C6.51796 5.74862 7.22628 7.00001 8.37305 7.00039H10.833L9.67578 4.82949ZM16.7725 4.59219C16.1261 3.78939 14.8304 3.8806 14.3242 4.82949L13.167 7.00039H15.627C16.774 7.00025 17.4824 5.74876 16.8926 4.76504L16.7725 4.59219Z"
                fill="currentColor"></path>
            </svg>
          </div>
          <div class="flex-1 min-w-0">
            <h4 class="text-subtitle2 text-t-primary font-medium mb-1">Rewards Hub</h4>
            <p class="text-caption1 text-t-third">Complete tasks to unlock rewards</p>
          </div>
        </a>
      </div>
    </div>
  </Transition>
</template>

<script>
export default {
  name: 'LandingPageRewardsDropdown',
  props: {
    isOpen: {
      type: Boolean,
      default: false
    }
  },
  emits: ['mouseenter', 'mouseleave'],
  methods: {
    handleMouseEnter() {
      this.$emit('mouseenter')
    },
    handleMouseLeave() {
      this.$emit('mouseleave')
    }
  }
}
</script>

<style scoped>
/* Анимация появления dropdown */
.dropdown-enter-active,
.dropdown-leave-active {
  transition: opacity 0.2s ease, transform 0.2s ease;
}

.dropdown-enter-from {
  opacity: 0;
  transform: translateY(-10px);
}

.dropdown-leave-to {
  opacity: 0;
  transform: translateY(-10px);
}

.dropdown-enter-to,
.dropdown-leave-from {
  opacity: 1;
  transform: translateY(0);
}
</style>
